import { createContext, useContext, useMemo, type PropsWithChildren } from "react";
import type { M1AppApi } from "../data/M1AppApi";
import { createDevelopmentM1AppApi } from "../data/developmentAppApi";

const AppStoreContext = createContext<M1AppApi | null>(null);

type AppStoreProviderProps = PropsWithChildren<{
  api?: M1AppApi;
}>;

export function AppStoreProvider({ api, children }: AppStoreProviderProps) {
  const value = useMemo(() => api ?? createDevelopmentM1AppApi(), [api]);
  return <AppStoreContext.Provider value={value}>{children}</AppStoreContext.Provider>;
}

export function useOptionalAppStore(): M1AppApi | null {
  return useContext(AppStoreContext);
}

export function useAppStore(): M1AppApi {
  const value = useOptionalAppStore();
  if (!value) throw new Error("useAppStore 必须在 AppStoreProvider 内使用");
  return value;
}
